<template>
  <div class="doc-content preview">
    <div class="markdown-body editormd-preview-container" v-html="html"></div>
  </div>
</template>

<script>
export default {
  props: ['html'],
  watch: {
    html() {
      this.$nextTick(()=> {
        function runScript(script) {
          const newScript = document.createElement('script');
          newScript.innerHTML = script.innerHTML;
          const src = script.getAttribute('src');
          if (src) newScript.setAttribute('src', src);
          document.head.appendChild(newScript);
          document.head.removeChild(newScript);
        }
        this.$nextTick(() => {
          const scripts = document.querySelector('.editormd-preview-container').querySelectorAll('script')
          for (let script of scripts) {
            runScript(script);
          }
        })
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.doc-content {
  padding: 50px 40px;
  box-sizing: border-box;
  margin-left: 260px;
}
.markdown-body,
.editormd-preview-container {
  padding: 0;
}
</style>